export const ROUTES = {
  paymentMethods: (orderId: number | string) =>
    `/order/${orderId}/payment-method`,
  bank: (orderId: number | string) => `/order/${orderId}/bank`,
  transaction: (orderId: number | string) => `/order/${orderId}/transaction`,
  paymentFailed: (orderId: number | string) =>
    `/order/${orderId}/transaction/failed`,
  paymentExpired: (orderId: number | string) =>
    `/order/${orderId}/transaction/expired`,
  directSendReceipt: (orderId: number | string) =>
    `/order/${orderId}/send-receipt`,
  transactionSendReceipt: (orderId: number | string) =>
    `/order/${orderId}/transaction/send-receipt`,
  transactionSuccessfully: (orderId: number | string) =>
    `/order/${orderId}/transaction/success`,
  noRequisite: (orderId: number | string) =>
    `/order/${orderId}/transaction/no-requisite`,
  feedbackSent: (orderId: number | string) =>
    `/order/${orderId}/transaction/feedback-sent`,
  recalculate: (orderId: number | string) =>
    `/order/${orderId}/transaction/recalculate`,
  paymentError: (orderId: number | string) =>
    `/order/${orderId}/transaction/error`,
  deepLinks: (orderId: number | string) =>
    `/order/${orderId}/transaction/deep-links`,
  return: (orderId: number | string) => `/order/${orderId}/return`,
};
